var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var Link = require('react-router').Link;
var Education = require('./layout/education.jsx');
var SubNav = require('./layout/subNav.jsx');
var Video = require( './layout/video.jsx' );
var ToolboxWidget = require('./layout/toolboxWidget.jsx');
var BackButton = require('../../components/backButton.jsx');
var EducationEditor = require( './layout/educationEditor.jsx' );
var PageEditor = require('./layout/pageEditor.jsx');
var VideoEditor = require('./layout/videoEditor.jsx');

var Qol = createReactClass({
	mixins: [PureRenderMixin],

    getInitialState: function () {
        return {
          editMode: false,
        };
    },

    componentDidMount: function() {
        if (this.props.params.name === 'new') {
            // Handle new symptom creation
            this.setState(Object.assign({}, this.state, {editMode: true}));
            const newTopic = {
              title: "New topic",
              topic: "new-topic",
              sections: [{ visible: true, format: 'html', title: '', content: '' }]
          }
          this.props.setSymptom({isActive: true, education: [newTopic], webEducation: [newTopic], meta: {}, featuredVideo: {}});
          } else {
            if(!this.isToolboxSelf()){
                this.props.fetchSymptomIfNeeded(this.props.params.name);
            }
            this.props.fetchToolboxIfNeeded('toolbox');
            this.relocateToolboxWidget();
        }
    },

    componentWillReceiveProps: function(nextProps){
        if(nextProps.params.name !== this.props.params.name && nextProps.params.name !== 'toolbox'){
            this.props.fetchSymptomIfNeeded(nextProps.params.name);
        }
    },

    componentDidUpdate: function(){
        if(this.hasDataLoaded()){
            this.relocateToolboxWidget();

			if(this.isToolboxSelf() && this.props.location.hash){
				$(window).resize();
			}
        }
    },

    relocateToolboxWidget: function(){
        var $toolboxWidget = $('.toolbox-widget');
        if($toolboxWidget.length && (this.isToolboxSelf() || $toolboxWidget.parents('.topic').length === 0)){
            if(this.isToolboxSelf()){
                $toolboxWidget.remove();
            }else if($toolboxWidget.parents('.topic').length === 0){
                if(Foundation.MediaQuery.atLeast('large')){
                    $('#information .topic:first-child').prepend($toolboxWidget);
                }else{
                    $('#information .topic:first-child').append($toolboxWidget);
                }

                $toolboxWidget.css('opacity', 1);
            }

            this.refs.subNav.reInitializeMagellan();
        }
    },

    isToolboxSelf: function(){
        return this.props.params.name === 'toolbox';
    },

    getQol: function(){
        return this.isToolboxSelf() ? this.props.toolbox : this.props.qol;
    },

    hasDataLoaded: function(){
        var qol = this.getQol();
        if (this.props.params.name === 'new' && qol.education) { return true };
        return !!(qol && qol.friendlyUrl === this.props.params.name
            && this.props.toolbox && this.props.toolbox.friendlyUrl === 'toolbox');
    },

    getName: function(educationItem){
        return educationItem.title;
    },

    openEditor: function(e){
      this.setState(Object.assign({}, this.state, {editMode: true}));
    },

    closeEditor: function(){
        this.setState(Object.assign({}, this.state, {editMode: false}));
    },

    submitForm: function(e, isNew) {
        var token = this.props.auth.token;
        var qol = this.props.qol;

        // Check for friendlyUrl change
        if (qol.friendlyUrl !== qol.newFriendlyUrl) {
            qol.friendlyUrl = qol.newFriendlyUrl;
            delete qol.newFriendlyUrl;
            this.props.setSymptom(qol);
        }

        if (isNew) {
            this.props.createSymptom(qol, 'qol', token);
        } else {
            this.props.updateSymptom(qol, token);
        }

        this.closeEditor();
      },

    handleChange: function(event, subfield) {
      var qol = this.props.qol;
      var toolbox = this.props.toolbox;

      if (event.target) {
        const inputValue = (event.target.type === 'checkbox') ? event.target.checked : event.target.value;
        if (subfield === 'featuredVideo') {
          toolbox[subfield][event.target.name] = inputValue;
          this.props.setToolbox(toolbox);
          return;
        } else if (subfield) {
          qol[subfield][event.target.name] = inputValue;
        } else {
          qol[event.target.name] = inputValue;
        }
      }

      this.props.setSymptom(qol);
    },

    setEducation: function(education) {
        const qol = this.props.qol;
        qol.education = education;
        this.props.setSymptom(qol);
    },

    getContent: function(){
      const { isAdmin = false } = this.props.auth;
      const isNew = this.props.params.name === 'new';
        var qol = this.getQol();
        var mainSection = [];

        if(this.hasDataLoaded()){
            mainSection = qol.education.filter(function(item) {
                return item.topic !== 'how_common' && item.topic !== 'learn_more';
            });
        }

        var children = [
            <Helmet
                title={(qol.meta && qol.meta.title) || qol.title}
                meta={[{
                    name: 'description',
                    content: (qol.meta && qol.meta.description) || qol.description
                }]}
                key={0} />,
			<div className="content-header-wrapper" key={'content-header-wrapper'}>
				<div className="row content-header">
					<div className="small-12 medium-3 column back show-for-medium">
						<Link to="/education" onClick={this.props.setActiveEducationToggle.bind(null, 'QOLS')}><span className="ion-ios-arrow-thin-left"></span> back to All MyQs</Link>
					</div>
					<div className="small-12 medium-6 column title">
						<h1>{qol.title}</h1>
					</div>
					<div className="small-12 medium-3 column"></div>
				</div>
			</div>,
			<div className="sub-nav-wrapper" id="sub-nav-wrapper" key={'sub-nav-wrapper'}>
				<SubNav
				   ref="subNav"
				   title={qol.title && qol.title.replace(/\?/g,'').replace(/\s+/g, '-').toLowerCase()}
				   name={qol.name}
				   education={mainSection}
				   getName={this.getName} />
		   	</div>,
			<BackButton key="back-button" />,
      this.state.editMode &&
        <div className='row editor-area' key={99}>
          <br />
          <div className="topic small-12 column">
              {(isNew) && <h2>Add new disease</h2> }
              <br />
              <EducationEditor
                  education={qol.education}
                  setEducation={this.setEducation} />
              <PageEditor
                  section="qols"
                  isActive={qol.isActive}
                  friendlyUrl={qol.friendlyUrl}
                  title={qol.title}
                  displayName={qol.displayName}
                  meta={qol.meta}
                  handleChange={this.handleChange} />
              <VideoEditor
                  video={this.props.toolbox.featuredVideo}
                  videoFieldName="featuredVideo"
                  handleChange={this.handleChange} />
          </div>
          <div className="small-12 column">
              <div className="action-field float-right">
                  <button className="alert button" type="submit" onClick={this.closeEditor}>Cancel</button>&nbsp;&nbsp;
                  <button className="blue button" type="submit" onClick={(e) => this.submitForm(e, isNew)}>{(isNew) ? "Create new" : "Save changes"}</button>
              </div>
          </div>
        </div>,
        	!this.state.editMode && qol.featuredVideo && qol.featuredVideo.title && <div id="hero-container" key={1}>
                <div id="hero">
                    <div className="row">
                        <div className="medium-centered medium-7 small-12 column">
                            <Video gender={this.props.auth.user.sex} video={qol.featuredVideo} />
                        </div>
                    </div>
                </div>
       	   </div>,
           !this.state.editMode && qol.name !== 'myqol' && <div className="toolbox-widget-wrapper" key="toolbox-widget"><ToolboxWidget toolbox={this.props.toolbox} clickTracking={this.props.recordEducationClick} /></div>,
           !this.state.editMode && <div className='editor-area' key={2}>
              {isAdmin &&
              <div className="row">
                <aside className="editor-actions">
                    <a title="Edit page" onClick={this.openEditor}>Edit page</a>
                </aside>
              </div>
              }
              <Education education={mainSection} />
            </div>
        ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return content;
    },

    render: function () {
        return (
            <div className="content fadeIn animated duration-750 delay-600">
                {this.getContent()}
            </div>
        );
    }
});

module.exports = Qol;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/qol.jsx